import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useState } from "react";
import { observer } from "mobx-react";
import { TemplateCenter, useTemplateCenterProvider } from "@devowl-wp/react-cookie-banner-admin";
import { useStores } from "../../../store";
import { ConfigContent } from "../content";
import { useLocationQuery } from "../../../hooks";
import { CookieEditForm } from ".";
const CookieTemplateCenter = observer(()=>{
    const { cookieStore } = useStores();
    const [fetched, setFetched] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState();
    // Allow to force a template by query argument so the template center is disabled
    const { force, attributes: queryAttributes, navigateAfterCreation = true } = useLocationQuery();
    const fetchTemplates = useCallback(async ()=>{
        if (!fetched) {
            setFetched(true);
            await cookieStore.fetchTemplatesServices();
        }
        const result = Array.from(cookieStore.templatesServices.values()).map((param)=>{
            let { data } = param;
            return data;
        });
        result.sort((a, b)=>a.headline.localeCompare(b.headline));
        return result;
    }, [
        fetched
    ]);
    const [TemplateCenterContextProvider, templateCenterContextValue] = useTemplateCenterProvider({
        type: "service",
        quickLinks: [
            "service-individual",
            "service-scanner",
            "cookie-experts"
        ],
        enableLocalFilter: true,
        syncTemplates: ()=>{
            return cookieStore.fetchTemplatesServices({
                storage: "redownload"
            });
        },
        fetchTemplates,
        fetchUse: async (identifier)=>{
            // We do currently not have a "pagination", just load all
            await fetchTemplates();
            return cookieStore.templatesServices.get(identifier).fetchUse();
        },
        initialSelection: force,
        onSelect: (template, initialSelection)=>setSelectedTemplate({
                identifier: template == null ? void 0 : template.identifier,
                version: template == null ? void 0 : template.version,
                overwriteAttributes: initialSelection && queryAttributes ? JSON.parse(queryAttributes) : undefined
            })
    });
    return selectedTemplate === undefined ? /*#__PURE__*/ _jsx(ConfigContent, {
        children: /*#__PURE__*/ _jsx(TemplateCenterContextProvider, {
            value: templateCenterContextValue,
            children: /*#__PURE__*/ _jsx(TemplateCenter, {})
        })
    }) : /*#__PURE__*/ _jsx(ConfigContent, {
        maxWidth: "fixed",
        children: /*#__PURE__*/ _jsx(CookieEditForm, {
            template: selectedTemplate.identifier ? {
                identifier: selectedTemplate.identifier,
                version: selectedTemplate.version
            } : undefined,
            navigateAfterCreation: navigateAfterCreation,
            overwriteAttributes: selectedTemplate.overwriteAttributes
        })
    });
});
export { CookieTemplateCenter };
